import { timer, map, take, filter, tap } from "rxjs";
import { Slugs } from "./slug.loader";
export class CdpaTimerComponent {
    constructor(element) {
        this.timerElement = element;
    }
    startCountdown$(duration) {
        // every second update the timer and emit when the timer is done
        return timer(0, 1000).pipe(take(duration + 1), map((i) => duration - i), tap((value) => CdpaTimerComponent.calculate(this.timerElement, value)), filter((value) => value === 0));
    }
    static calculate(element, value) {
        const minutes = Math.floor(value / 60);
        const seconds = (value % 60).toString().padStart(2, "0");
        const timeSlug = minutes > 0 ? Slugs.translated.min : Slugs.translated.sec;
        element.innerHTML = `${minutes}:${seconds} ${timeSlug}`;
    }
}
